import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("题库")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("上一题")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("下一题")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { mode: "ios" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, {
            mode: "ios",
            color: "tertiary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "secondary" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    href: "/",
                    fill: "clear"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.chevronBackSharp
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.que.num), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.que.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, { mode: "ios" }, {
                    default: _withCtx(() => [
                      (_ctx.que.a)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 0,
                            mode: "ios"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.que.a), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_checkbox, {
                                mode: "ios",
                                slot: "start",
                                value: "a",
                                color: "secondary",
                                modelValue: _ctx.item.a,
                                onIonChange: _ctx.checkAnswer
                              }, null, 8, ["modelValue", "onIonChange"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.que.b)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 1,
                            mode: "ios"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.que.b), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_checkbox, {
                                mode: "ios",
                                slot: "start",
                                value: "b",
                                color: "secondary",
                                modelValue: _ctx.item.b,
                                onIonChange: _ctx.checkAnswer
                              }, null, 8, ["modelValue", "onIonChange"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.que.c)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 2,
                            mode: "ios"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.que.c), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_checkbox, {
                                mode: "ios",
                                slot: "start",
                                value: "c",
                                color: "secondary",
                                modelValue: _ctx.item.c,
                                onIonChange: _ctx.checkAnswer
                              }, null, 8, ["modelValue", "onIonChange"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.que.d)
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 3,
                            mode: "ios"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.que.d), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_checkbox, {
                                mode: "ios",
                                slot: "start",
                                value: "d",
                                modelValue: _ctx.item.d,
                                color: "secondary",
                                onIonChange: _ctx.checkAnswer
                              }, null, 8, ["modelValue", "onIonChange"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { style: {"text-align":"center"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAnswer = !_ctx.showAnswer)),
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.showAnswer ? '隐藏答案' : '显示答案'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { style: {"text-align":"center"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "secondary",
                        onClick: _ctx.preQue
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { style: {"text-align":"center"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "tertiary",
                        onClick: _ctx.nextQue
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.showAnswer)
            ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.que.answer), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}